module.exports = "/images/vendor/pdfjs-dist/web/shadow.png?020ca14de41fcc6c4d0b8bfff2ad9b3c";